






import Vue, { PropType } from "vue";
import ice from "../../lib/ice";
import { mapActions } from "vuex";
import {
  GetLoginSharingCodeRequest,
  GetLoginSharingCodeResponse
} from "@/containers/loginSharing/api";

export interface VueApplyPlanButtonProps {
  href: string;
  ipadHref: string;
  target: string;
  serial: string;
  notInstalledMessage: string;
  loginSharingPageName: string;
}

export default Vue.extend({
  name: "vc-open-clip-studio-paint-button-with-login-sharing",
  props: {
    href: {
      type: String as PropType<VueApplyPlanButtonProps["href"]>,
      default: ""
    },
    ipadHref: {
      type: String as PropType<VueApplyPlanButtonProps["ipadHref"]>,
      default: ""
    },
    target: {
      type: String as PropType<VueApplyPlanButtonProps["target"]>,
      default: "_self"
    },
    serial: {
      type: String as PropType<VueApplyPlanButtonProps["serial"]>,
      default: ""
    },
    notInstalledMessage: {
      type: String as PropType<VueApplyPlanButtonProps["notInstalledMessage"]>,
      default:
        "CLIP STUDIO PAINTが起動しない場合、:brCLIP STUDIO PAINTを再インストールしてください。"
    },
    loginSharingPageName: {
      type: String as PropType<VueApplyPlanButtonProps["loginSharingPageName"]>,
      default: "vc-open-clip-studio-paint-button-with-login-sharing"
    }
  },
  methods: {
    ...mapActions("loginSharing", ["getLoginSharingCode"]),
    onClickButton(e: Event) {
      if (ice.isIce()) {
        ice.runPaint(this.serial);
        return;
      }

      let setTimeoutId = setTimeout(() => {
        alert(this.notInstalledMessage.replace(":br", "\n"));
      }, 5000);
      window.addEventListener("blur", event => {
        clearTimeout(setTimeoutId);
        this.clearScreenLock();
      });

      const agent = window.navigator.userAgent.toLowerCase();
      const isIpad =
        agent.indexOf("ipad") > -1 ||
        (agent.indexOf("macintosh") > -1 && "ontouchend" in document);
      if (isIpad) {
        window.open(this.ipadHref, this.target);
        return;
      }

      if (this.href.startsWith("clipstudio://")) {
        (async () => {
          let iceScheme = this.href;
          try {
            const requestData: GetLoginSharingCodeRequest = {
              pageName: this.loginSharingPageName
            };
            const res: GetLoginSharingCodeResponse = await this.getLoginSharingCode(
              requestData
            );
            iceScheme =
              this.href +
              (() => {
                if (this.href.includes("?")) {
                  return "&";
                }
                if (this.href.endsWith("/")) {
                  return "?";
                }
                return "/?";
              })() +
              "commonparametertype[]=login_sharing" +
              "&login_sharing_code=" +
              res.loginSharingCode +
              "&login_sharing_valid_seconds=" +
              res.loginSharingValidSeconds;
          } catch (error) {
            iceScheme = this.href;
          }
          window.open(iceScheme, this.target);
        })();
      } else {
        window.open(this.href, this.target);
        return;
      }
    },
    clearScreenLock() {
      if (typeof window.CustomEvent === "function") {
        let callIceEvent = new CustomEvent("callIce");
        window.dispatchEvent(callIceEvent);
      }
    }
  }
});
